import { Image } from 'AbstractElements';
import AudioPlayer from 'Component/Learning/DetailSubMateri/AudioPlayer';
import VideoPlayer from 'Component/Learning/DetailSubMateri/VideoPlayer';
import { Fragment } from 'react';
import Dropzone from 'react-dropzone-uploader';
import { Form, Label, FormGroup, Spinner } from 'reactstrap';

const CommonDropzone = ({ height = 50, maxFiles = 1, ...props }) => {
  return (
    <Fragment>
      <FormGroup className='mb-3'>
        <Form className="m-b-20" encType="multipart/form-data">
          <Label for="validationImage" style={{ fontWeight: 'bold' }}>
            <div className="d-flex align-items-center gap-2">
              {props.label}:
              {
                props.gapiInitialized &&
                <button type='button' className="rounded-circle btn btn-outline-primary" style={{ padding: "5px 5px 0 5px" }} onClick={props.handleLoginAndPickFile} disabled={props.loadingDriveFile || props.isDropFile}>
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" style={{ width: '1.5rem', height: '1.5rem' }} viewBox="0 0 48 48">
                    <path fill="#1e88e5" d="M38.59,39c-0.535,0.93-0.298,1.68-1.195,2.197C36.498,41.715,35.465,42,34.39,42H13.61 c-1.074,0-2.106-0.285-3.004-0.802C9.708,40.681,9.945,39.93,9.41,39l7.67-9h13.84L38.59,39z"></path><path fill="#fbc02d" d="M27.463,6.999c1.073-0.002,2.104-0.716,3.001-0.198c0.897,0.519,1.66,1.27,2.197,2.201l10.39,17.996 c0.537,0.93,0.807,1.967,0.808,3.002c0.001,1.037-1.267,2.073-1.806,3.001l-11.127-3.005l-6.924-11.993L27.463,6.999z"></path><path fill="#e53935" d="M43.86,30c0,1.04-0.27,2.07-0.81,3l-3.67,6.35c-0.53,0.78-1.21,1.4-1.99,1.85L30.92,30H43.86z"></path><path fill="#4caf50" d="M5.947,33.001c-0.538-0.928-1.806-1.964-1.806-3c0.001-1.036,0.27-2.073,0.808-3.004l10.39-17.996 c0.537-0.93,1.3-1.682,2.196-2.2c0.897-0.519,1.929,0.195,3.002,0.197l3.459,11.009l-6.922,11.989L5.947,33.001z"></path><path fill="#1565c0" d="M17.08,30l-6.47,11.2c-0.78-0.45-1.46-1.07-1.99-1.85L4.95,33c-0.54-0.93-0.81-1.96-0.81-3H17.08z"></path><path fill="#2e7d32" d="M30.46,6.8L24,18L17.53,6.8c0.78-0.45,1.66-0.73,2.6-0.79L27.46,6C28.54,6,29.57,6.28,30.46,6.8z"></path>
                  </svg>
                </button>
              }
              {
                (props.gapiInitialized && (props.driveFile !== null && props.driveFile !== undefined)) &&
                <svg style={{ cursor: 'pointer' }} onClick={() => {
                  props.setDriveFile(null)
                  props.setIsDropFile(false)
                }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
              }
            </div>
          </Label>
          <div style={{ height: props.driveFile || props.loadingDriveFile ? "auto" : '0px', padding: props.driveFile || props.loadingDriveFile ? "5px 0" : '0px' }}>
            {
              props.loadingDriveFile ? (
                <div className="loader-box">
                  <Spinner attrSpinner={{ className: 'loader-30' }} />
                </div>
              ) : props.driveFile ?
                props.driveFile?.blob?.type?.startsWith('image/') ? (
                  <div className="embed-responsive embed-responsive-16by9">
                    <Image attrImage={{ className: 'img-fluid', src: URL.createObjectURL(props.driveFile.blob), width: '500px', alt: props.driveFile.name }} />
                  </div>
                ) : props.driveFile.blob.type.startsWith('audio/') ? (
                  <AudioPlayer link={URL.createObjectURL(props.driveFile.blob)} />
                ) : props.driveFile.blob.type.startsWith('video/') ? (
                  <VideoPlayer link={URL.createObjectURL(props.driveFile.blob)} width={720} />
                ) : <div>Unsupported file type</div>
                : <></>
            }
          </div>
          <div className="m-0 dz-message needsclick">
            <Dropzone
              key={props.key}
              onChangeStatus={props.handleChangeStatus}
              maxFiles={maxFiles == "unlimited" ? undefined : maxFiles}
              canCancel={false}
              inputContent={props.inputContent}
              disabled={props.loadingDriveFile || props.driveFile}
              styles={{
                dropzone: { width: '100%', height },
                dropzoneActive: { borderColor: 'green' },
              }}
              accept={props.accept}
            />
          </div>
        </Form>
      </FormGroup>
    </Fragment>
  );
};

export default CommonDropzone;